<template>
  <div class="sidebar">
    <ul class="menu">
      <li class="menu-nm active" @click="move('managePaltform')">통합수강신청</li>
      <li>
        <ul class="sub-menu">
          <li
            class="menu-nm"
            :class="{ active: curPath === 'managePaltform' || curPath === 'company-list' || curPath === 'company-companyInquiry-companyIdx' }"
            @click="move('managePaltform')">
            플랫폼 관리
          </li>
          <li class="menu-nm" :class="{ active: curPath === 'platform-platformManage' }" @click="move('platform-platformManage')">플랫폼 생성</li>
          <li class="menu-nm" :class="{ active: curPath === 'faq-faqList' }" @click="move('faq-faqList')">FAQ 관리</li>
          <li class="menu-nm" :class="{ active: curPath === 'global-globalTutor' }" @click="move('global-globalTutor')">글로벌 강사관리</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { onMounted, ref, watch } from '@vue/runtime-core';
import { useRouter, useRoute } from 'vue-router';
export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const curPath = ref(null);

    const move = page => {
      router.push({ name: page });
    };

    onMounted(() => {
      const { name } = route;
      curPath.value = name;
    });

    watch(route, cur => {
      const { name } = cur;
      curPath.value = name;
    });

    return {
      move,
      route,
      curPath,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.sidebar {
  background-color: $side-bg-color;
  height: 100%;
  padding-right: 0;
  color: $side-text-color;

  a {
    display: block;
    color: $black;
    padding: 16px;
    text-decoration: none;
    cursor: pointer;
  }

  a.active {
    background-color: $side-text-active;
    color: $white;
  }

  .menu,
  .sub-menu {
    list-style: none;
    padding: 16px;
    margin-bottom: 0;

    .menu-nm {
      cursor: pointer;
    }

    .menu-nm.active {
      color: $side-text-active;
    }

    .menu-nm:hover {
      color: $side-text-active;
    }
  }

  .sub-menu {
    padding-left: 20px;
    padding-top: 10px;
    padding-right: 0;
    padding-bottom: 10px;

    li {
      padding-bottom: 10px;
      cursor: pointer;
    }
  }
}
</style>
